/**
 * SENVÈ cart drawer — "complete the ritual" suggestion row.
 *
 * Adds the suggested variant via /cart/add.js and hands the response straight
 * to Dawn's own <cart-drawer>.renderContents(), the same path
 * senve-ritual-selector.js uses. Because the row lives inside the drawer's
 * .js-contents block, that re-render also re-evaluates the suggestion in
 * Liquid — so the row updates or disappears on its own with no client-side
 * suggestion logic to keep in sync.
 *
 * Listeners are delegated off the document so they survive every re-render
 * (the row's own DOM node is replaced each time).
 */
(() => {
  const SELECTOR = '[data-senve-suggest-add]';

  function showError(button, message) {
    const wrapper = button.closest('[data-senve-cart-suggest]');
    const errorEl = wrapper && wrapper.querySelector('[data-senve-suggest-error]');
    if (!errorEl) return;
    errorEl.textContent = message;
    errorEl.hidden = false;
  }

  function addSuggestion(button) {
    if (button.getAttribute('aria-disabled') === 'true') return;

    const variantId = button.dataset.variantId;
    if (!variantId) return;

    button.setAttribute('aria-disabled', 'true');
    button.classList.add('loading');

    const drawer = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    const body = { items: [{ id: variantId, quantity: 1 }] };

    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      body.sections = drawer.getSectionsToRender().map((section) => section.id);
      body.sections_url = window.location.pathname;
      if (typeof drawer.setActiveElement === 'function') drawer.setActiveElement(document.activeElement);
    }

    fetch(window.routes ? window.routes.cart_add_url : '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          button.setAttribute('aria-disabled', 'false');
          button.classList.remove('loading');
          showError(button, response.description || response.message || 'Something went wrong. Please try again.');
          return;
        }
        // On success the drawer re-renders and this button is discarded, so
        // there is nothing to un-disable here.
        if (drawer && typeof drawer.renderContents === 'function') {
          drawer.renderContents(response);
        } else {
          window.location = window.routes ? window.routes.cart_url : '/cart';
        }
        if (window.publish && window.PUB_SUB_EVENTS) {
          window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
            source: 'senve-cart-suggest',
            cartData: response,
          });
        }
      })
      .catch(() => {
        button.setAttribute('aria-disabled', 'false');
        button.classList.remove('loading');
        showError(button, 'Something went wrong. Please try again.');
      });
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest ? event.target.closest(SELECTOR) : null;
    if (!button) return;
    event.preventDefault();
    addSuggestion(button);
  });
})();
